import { GetStaticProps } from "next";

import Docs from "../../components/Docs";

import {
  DocsPageProps,
  getDocsPageMarkdown,
  getStaticDocs,
} from "../../utils/docs";
import { FlashPCBPage } from "../../models/page";
import settings from "../../constants/settings";
import { FlashPCBSettings } from "../../utils/settings";

const DocPage: FlashPCBPage<DocsPageProps> = ({
  title,
  staticDocs,
  markdown,
  flashPCBSettings,
}) => {
  return (
    <Docs
      title={title}
      staticDocs={staticDocs}
      markdown={markdown}
      flashPCBSettings={flashPCBSettings}
    />
  );
};

export const getStaticProps: GetStaticProps = async () => {
  const response = await fetch(`${settings.api_url}/settings`);
  const flashPCBSettings = (await response.json()) as FlashPCBSettings;

  const staticDocs = getStaticDocs();
  const firstSidebarItem = staticDocs.pages[0]!;
  const markdown = getDocsPageMarkdown(firstSidebarItem.path);
  return {
    props: {
      title: "Documentation",
      staticDocs,
      markdown,
      flashPCBSettings,
    } as DocsPageProps,
    revalidate: 60 * 60 * 24, // daily
  };
};

export default DocPage;
